import React, { useRef, useEffect } from 'react'
import Chart, { ChartData } from 'chart.js/auto'
import styled from 'styled-components'
import { SimulationsResponse } from '../../../types/API'

interface ExecutionsUnreachedChartProps {
  data: SimulationsResponse
}

const ExecutionsUnreachedChart: React.FC<ExecutionsUnreachedChartProps> = ({ data }) => {
  const lineData: Record<string, number> = {}
  let totalizer = 0

  for (const [date, { executionNotReached }] of Object.entries(data)) {
    if (lineData[date]) {
      lineData[date] += executionNotReached
    } else {
      lineData[date] = executionNotReached
    }

    if (executionNotReached) {
      totalizer += executionNotReached
    }
  }

  const processData = () => {
    const allDateLabels = Object.keys(data)
    allDateLabels.sort()
    return { dateLabels: allDateLabels }
  }

  const { dateLabels } = processData()

  const chartData: ChartData<'line', number[], string> = {
    labels: dateLabels,
    datasets: [
      {
        type: 'line',
        fill: true,
        label: 'Unreached Executions',
        yAxisID: 'tasks-y-axis',
        data: Object.values(lineData),
        borderColor: 'rgba(125,129,131,0.34)',
        backgroundColor: 'rgba(60,72,79,0.34)',
        pointBackgroundColor: 'rgba(125,129,131,0.34)',
        tension: 0.8,
        pointRadius: 7,
        pointHoverRadius: 10,
        pointHoverBackgroundColor: 'rgba(125,129,131,0.34)',
        pointHoverBorderColor: 'rgba(125,129,131,0.34)',
      },
    ],
  }

  const canvasRef = useRef<HTMLCanvasElement | null>(null)
  const chartRef = useRef<Chart | null>(null)

  const createChart = () => {
    if (canvasRef.current) {
      const ctx = canvasRef.current.getContext('2d')
      if (ctx) {
        chartRef.current = new Chart(ctx, {
          type: 'bar',
          data: chartData,
          options: {
            responsive: true,
            scales: {
              'tasks-y-axis': {
                beginAtZero: true,
              },
            },
          },
        })
      }
    }
  }

  const destroyChart = () => {
    if (chartRef.current) {
      chartRef.current.destroy()
    }
  }

  useEffect(() => {
    createChart()

    return () => {
      destroyChart()
    }
  }, [data])

  return (
    <>
      <h1>Unreached Executions {totalizer > 0 && <Tot>Total: {totalizer}</Tot>}</h1>
      <div>
        <canvas ref={canvasRef} />
      </div>
    </>
  )
}

const Tot = styled.p`
  font-size: 14px;
  display: inline-flex;
  background: rgba(125, 129, 131, 0.34);
  padding: 5px 10px;
  border-radius: 22px;
  margin-left: 18px;
`

export default ExecutionsUnreachedChart
